import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation  } from "react-router-dom";

export default function ManageDropdown() {
    const [toggleManageDropDown, setToggleManageDropdown] = useState(false);
    const [selectedItem, setSelectedItem] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);

    const handleDropdown = () => {
        setToggleManageDropdown((prev) => !prev);
    }

    const handleItemSelect = (item) => {
        setSelectedItem(item);

         if (item === "All") {
            navigate("/landingpage");
        } else if (item === "Zones") {
            navigate("/managepod");
        } else if (item === "Units") {
            navigate("/manageunits");
        } else if (item === "Properties") {
            navigate("/manageproperties")
        }
    };

    useEffect(() => {
        if (
            location.pathname !== "/manageunits" &&
            location.pathname !== "/managepod" && location.pathname !== "/manageproperties"
        ) {
            setSelectedItem(""); // Clear the selection
        }
    }, [location.pathname]);

    const menuItems = ["All", "Zones", "Units", "Properties"];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setToggleManageDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="manageBtnHolder hidden md:flex" ref={dropdownRef}>
            <button data-testid="assets-menu-toggle" className="bg-[#1E555C] dark:darkThemeGradiantBg px-3 flex items-stretch h-9 rounded-md w-auto relative" onClick={handleDropdown}>
                <div className="flex items-center grow text-white text-sm pr-3 font-semibold leading-3 lg:text-base lg:leading-5 tracking-[0.024px]">Assets</div>
                <div className="flex gap-x-2.5 items-center">
                    <div className="pipe h-full w-[1px] bg-white/30"></div>
                    <div className="dropdownHolder  flex-0 flex justify-center items-center basis-6 shrink-0 grow-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19 9L12 15L5 9" stroke="#FF8C65" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
                {toggleManageDropDown && (
                    <div className="dropdownMenuHolder absolute top-full mt-5 right-0 left-0 shadow-appShadow dark:shadow-darkThemeDropdownMenuShadow w-full rounded-md">
                        <ul className="bg-white dark:bg-darkThemeDropdownBg rounded-lg w-full flex flex-col">
                            {menuItems.map((item, index) => (
                                <li
                                    key={index}
                                    data-testid={`assets-menu-${item.toLowerCase()}`}
                                    onClick={() => handleItemSelect(item)}
                                    className={`px-3 py-2.5 text-dark-grey dark:text-white text-xs text-left leading-4 lg:text-sm lg:leading-5 font-normal tracking-[-0.408px] border-b border-[#AFC3BC99] dark:border-darkThemeBorder flex justify-between items-center gap-2 cursor-pointer
                                        ${item === selectedItem ? "bg-[#FFF1C6] dark:bg-darkThemeDropdownItemBg" : ""} 
                                        ${index === menuItems.length - 1 ? "border-b-0" : ""}`}
                                >
                                    <span className="basis-10/12 truncate">{item}</span>
                                    {item === selectedItem && (
                                        <span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                            >
                                                <path
                                                    d="M8.49215 15C8.24102 15 8.00244 14.8995 7.82665 14.7238L4.27311 11.1702C3.90896 10.8061 3.90896 10.2033 4.27311 9.8392C4.63725 9.47506 5.23997 9.47506 5.60412 9.8392L8.49215 12.7272L14.9463 6.27311C15.3104 5.90896 15.9132 5.90896 16.2773 6.27311C16.6414 6.63725 16.6414 7.23997 16.2773 7.60412L9.15766 14.7238C8.98186 14.8995 8.74329 15 8.49215 15Z"
                                                    fill="#FF8C65"
                                                />
                                            </svg>
                                        </span>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </button>
        </div>
    );
}